import { PositionEntity } from 'src/entities/PositionEntity';
import { ShipmentOrderLegRunForPlanEntity } from 'src/entities/ShipmentOrderLegRun.entity';

/** 線の色。旧地図と同じ primary（V3Plans OrderPolylinePresenter.tsx:40） */
export const UNASSIGNED_POLYLINE_COLOR = '#5569ff';

export type UnassignedPolyline = { id: number; positions: [PositionEntity, PositionEntity] };

/** 座標は API から文字列で来る。数値にできない値は座標として扱わない */
function toCoord(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * 選択中の未割当案件について、積地と降地を結ぶ線を作る。
 * V3Plans (presenters/OrderPolylinePresenter.tsx:27-32) と同じ 2 点。
 *
 * 「どこからどこへ運ぶ案件か」は点だけでは読めない。選んだ案件だけ線を出す。
 *
 * Why 座標が欠けたら線にしない: NaN を渡すと leaflet が描画中に例外を投げ、
 * 地図全体が消える（未割当ピンで実際に踏んだ経路と同じ）。
 */
export function buildUnassignedPolylines(
  selectedUnassignedIds: ReadonlySet<string>,
  legRuns: readonly ShipmentOrderLegRunForPlanEntity[],
): UnassignedPolyline[] {
  const lines: UnassignedPolyline[] = [];

  legRuns.forEach((lr) => {
    if (!selectedUnassignedIds.has(`lr-${lr.id}`)) return;

    const loadingLat = toCoord(lr.loading_lat);
    const loadingLng = toCoord(lr.loading_lng);
    const unloadingLat = toCoord(lr.unloading_lat);
    const unloadingLng = toCoord(lr.unloading_lng);
    if (loadingLat == null || loadingLng == null || unloadingLat == null || unloadingLng == null) return;

    lines.push({ id: lr.id, positions: [[loadingLat, loadingLng], [unloadingLat, unloadingLng]] });
  });

  return lines;
}
